import React from 'react';
import { gridBorder, gridCell } from './styles';
import { border } from '../styles';

const DataCell = ({
    rowIndex,
    scrollPxH = 0,
    scrollPxV = 0,
    style,
    isSticky,
    isHighlighted = false,
    deleteRowSelected,
    onHover,
    highlightedIdx,
    setHighlightedIdx,
    highlightOnClick = false,
    ...props
}) => {
    const cell = {
        ...gridBorder,
        ...gridCell,
        boxSizing: 'border-box',
        backgroundColor: rowIndex === highlightedIdx
            ? '#FDF1D6'
            : isHighlighted
                ? '#dcffff'
                : deleteRowSelected
                    ? '#FDF1D6'
                    : rowIndex % 2 === 0
                        ? '#f7f7f7'
                        : '#ffffff',
        bottom: scrollPxV,
        ...(isSticky
            ? {
                zIndex: 100 - rowIndex
            }
            : {
                right: scrollPxH
            }),
        borderRight: isHighlighted ? 'solid 1px #b9d7d7' : border,
        borderBottom: isHighlighted ? 'solid 1px #b9d7d7' : border,
        height: 52,
        ...style
    };

    const hoverEvents = {};
    if (typeof onHover === 'function') {
        hoverEvents.onMouseOver = () => onHover(rowIndex);
        hoverEvents.onMouseLeave = () => onHover(-1);
    }

    const highlightClick = () => {
        if (highlightOnClick) {
            setHighlightedIdx(rowIndex);
        }
    }

    return <td onClick={highlightClick} style={cell} {...props} {...hoverEvents} />;
};

export default DataCell;
